<div class="header">
  <ng-content select="[header]"></ng-content>
</div>
<div class="body">
  <ng-content select="[body]"></ng-content>
</div>
